























































import { Component, Prop } from "vue-property-decorator";
import {
  KitDinamico,
  ItemKitDinamico,
  KitsDinamicosService,
} from "@/services/kits-dinamicos.service";
import { moeda } from "@/shared/filters";
import InputMoeda from "@/shared/components/input-moeda.vue";
import DatePicker from "@/shared/components/date-picker.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import DataTable from "@/shared/components/data-table.vue";
import AssociarProdutoKitDinamico from "./AssociarProdutoKitDinamico.vue";
import ItemKitDinamicoForm from "./ItemKitDinamicoForm.vue";
import Confirm from "@/shared/components/confirm.vue";
import Loading from "@/shared/components/loading.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
@Component({
  components: {
    InputMoeda,
    DatePicker,
    DataTable,
    AssociarProdutoKitDinamico,
    Tooltip,
    Confirm,
    ItemKitDinamicoForm,
    Loading,
  },
  filters: { moeda },
})
export default class ItemsKitDinamico extends mixins(GlobalMixin) {
  @Prop() kitdinamico!: KitDinamico;

  headers = [
    { value: "sequencia", text: "Sequência" },
    { value: "descricao", text: "Descrição" },
    { value: "produtos.length", text: "Qtd Produtos Selecionáveis" },
    { value: "valor", text: "Valor" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  async novoItem() {
    const modalItemKit = this.$refs.modalItemKit as ItemKitDinamicoForm;
    const res = await modalItemKit.novo(this.kitdinamico.idKitDinamico!);

    if (res) {
      this.$emit("saved");
    }
  }

  async editarItem(item: ItemKitDinamico) {
    const modalItemKit = this.$refs.modalItemKit as ItemKitDinamicoForm;
    const res = await modalItemKit.alterar(item);

    if (res) {
      this.$emit("saved");
    }
  }

  async excluirItem(item: ItemKitDinamico) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir Item ${item.descricao}`;
    const text = `Deseja realmente excluir o item e todo seu conteúdo ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await KitsDinamicosService.deletarItemKitDinamico(
        item.idItemKitDinamico!
      ).finally(this.stopLoader);
      this.$emit("saved");
    }
  }

  async subirItem(item: ItemKitDinamico) {
    await KitsDinamicosService.ordenarItemKitDinamico({
      idKitDinamico: item.kitDinamico?.idKitDinamico!,
      idItemKitDinamico: item.idItemKitDinamico!,
      step: -1,
    });
    this.$emit("saved");
  }

  async descerItem(item: ItemKitDinamico) {
    await KitsDinamicosService.ordenarItemKitDinamico({
      idKitDinamico: item.kitDinamico?.idKitDinamico!,
      idItemKitDinamico: item.idItemKitDinamico!,
      step: 1,
    });
    this.$emit("saved");
  }

  async novoItemProduto(item: ItemKitDinamico) {
    const modal = this.$refs.associarProduto as AssociarProdutoKitDinamico;
    await modal.novoItemProdutoKitDinamico(item);
    this.$emit("saved");
  }
}
